module.exports = __webpack_public_path__ + "static/media/SarahSwitek_11_Questions-Conclusion_3.e43324cd.mp3";